/** Debounce delay before an edited filter query hits Nexus. */
export const PROFILE_POSTS_FILTER_DEBOUNCE_MS = 500;
